import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("apex_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("apex_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.product_id === product.id);
      if (exists) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          sku: product.sku,
          image_url: product.image_url,
          rate: product.rate,
          moq: product.moq,
          pack_size: product.pack_size,
          unit: product.unit,
          stock_on_hand: product.stock_on_hand,
          tier_prices: product.tier_prices || [],
          quantity,
        },
      ];
    });
  };

  const updateQty = (productId, quantity) =>
    setItems((prev) => prev.map((i) => (i.product_id === productId ? { ...i, quantity } : i)));

  const removeItem = (productId) =>
    setItems((prev) => prev.filter((i) => i.product_id !== productId));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
